import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';

import {
  makeStyles,
  Button,
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

import Reserve from '../../../types/IAppReservesStore';
import { parsePhoneNumber } from '../../../helpers/reserveHelpers';

const useStyles = makeStyles((theme: Theme) => ({
  actionButton: {
    boxShadow: 'none',
    borderRadius: 0,
    height: '100%', // Занимает всю высоту nav
    padding: '0 12px !important', // Минимальный padding для текста
    [theme.breakpoints.only('xs')]: {
      padding: '0 10px !important',
      fontSize: 14,
    },
    [theme.breakpoints.only('sm')]: {
      padding: '0 11px !important',
      fontSize: 15,
    },
  },
  buttonBorder: {
    borderRight: '1px solid #e7ebee',
  },
  reserveButton: {
    backgroundColor: '#e7ebee',

    '& .MuiButton-label': {
      color: 'rgba(50, 50, 50, 0.5)',
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
    },

    '&:hover .MuiButton-label': {
      color: 'rgba(50, 50, 50, 1)',
    },
  },
  activeReserve: {
    backgroundColor: 'white',
    '& .MuiButton-label': {
      color: 'rgba(50, 50, 50, 1)',
    },
  },
  reserveWarning: {
    backgroundColor: 'rgba(244, 88, 88, 0.2)',
    transition: 'background 3s ease',
    '& .MuiButton-label': {
      transition: 'color 3s ease',
      color: 'rgba(50, 50, 50, 1)',
    },
  },
  reserveWarningOn: {
    backgroundColor: '#e7ebee',
    '& .MuiButton-label': {
      color: 'rgba(50, 50, 50, 0.5)',
    },
  },
  addButton: {
    '& svg': {
      fontSize: 28,
    },
  },
}));

interface IProps {
  reserve: Reserve;
  onClick: () => void;
  open: boolean;
  width?: number;
}


const NavItem: React.FunctionComponent<IProps> = ({
  reserve,
  onClick,
  open,
  width,
}) => {
  const [params, setParams] = useState({
    attention: false,
    warning: false,
  });

  const { attention, warning } = params;
  
  const timeoutIdsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    setParams(prevState => ({
      ...prevState,
      attention: !open && reserve.type === 'WIDGET' && reserve.outerChangeType !== 'CANCELED',
    }));
  }, [open, reserve.type, reserve.outerChangeType]);

  useEffect(() => {
    const interval = setInterval(() => {
      setParams(prevState => ({
        ...prevState,
        warning: prevState.attention,
      }));

      const timeoutId = setTimeout(() => {
        setParams(prevState => ({
          ...prevState,
          warning: false,
        }));
      }, 3000);
      
      timeoutIdsRef.current.push(timeoutId);
    }, 5000);

    return () => {
      clearInterval(interval);
      // Очищаем все активные таймауты
      timeoutIdsRef.current.forEach(timeoutId => clearTimeout(timeoutId));
      timeoutIdsRef.current = [];
    };
  }, []);

  const {
    actionButton,
    buttonBorder,
    reserveButton,
    activeReserve,
    reserveWarning,
    reserveWarningOn,
  } = useStyles();

  const cssNames = classNames([
    actionButton,
    buttonBorder,
    reserveButton,
    open && activeReserve,
    attention && reserveWarning,
    attention && warning && reserveWarningOn,
  ]);

  const title = [];
  const name = [];

  if (reserve.payload) {
    const { firstName, lastName, phone } = reserve.payload;

    if (firstName) {
      name.push(firstName);
    }

    if (lastName) {
      name.push(lastName);
    }

    if (name.length || phone) {
      title.push(name.join(' '));
      title.push((phone && parsePhoneNumber(phone)) || '');
    }
  }

  return (
    <Button
      onClick={() => onClick()}
      disabled={open}
      className={cssNames}
      style={width ? { width } : {}}
    >
      {(title && title.join(', ')) || 'Новый резерв'}
    </Button>
  );
};

export default NavItem;
